export default function getImageURL(sid?: number | string | null) {
  const validatedSid = sid === undefined || sid === null ? '0' : sid;
  return `https://${process.env.REACT_APP_AWS_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_S3_REGION}.amazonaws.com/public/sites/${validatedSid}/images/profile-logo/${validatedSid}.png`
}
